import { languages } from 'app/config/translation';
import theme from 'app/shared/theme';
import { useAppSelector } from 'app/store/store';

export const useAppTheme = () => {
  const currentLocale = useAppSelector(state => state.locale.currentLocale);

  const customization = {
    themeName: 'scoringJoe',
    palette: {
      // mode: 'dark'
      // variant: 'forest',
    },
  };

  return theme(customization, languages[currentLocale]?.mui);
};
